import { Header, StatisticsInfo } from './components';
import { ReleasesStatsContainer } from './styled';

const ReleasesStats = () => (
  <ReleasesStatsContainer>
    <Header />
    <StatisticsInfo />
  </ReleasesStatsContainer>
);

export default ReleasesStats;
